import { isPlatformServer, JsonPipe, NgIf } from '@angular/common';
import { Component, ElementRef, forwardRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { HelperFunctions, IActivityLocation, IBoondockPoint, ILatLon, IListingPoint } from '@curbnturf/entities';
import { HereMapContextMenuComponent } from '@curbnturf/map/src/lib/here-map-context-menu/here-map-context-menu.component';
import { HereMapComponent } from '@curbnturf/map/src/lib/here-map/here-map.component';
import { ActivityCardComponent } from '@curbnturf/search-components/src/lib/activity-card/activity-card.component';
import { SearchDisplayCardComponent } from '@curbnturf/search-components/src/lib/search-display-card/search-display-card.component';
import { UserPointCardComponent } from '@curbnturf/search-components/src/lib/user-point-card/user-point-card.component';
import { IonicModule } from '@ionic/angular';

@Component({
  standalone: true,
  selector: 'curbnturf-location-map',
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.scss'],
  imports: [
    ActivityCardComponent,
    HereMapComponent,
    forwardRef(() => HereMapContextMenuComponent),
    IonicModule,
    JsonPipe,
    NgIf,
    SearchDisplayCardComponent,
    UserPointCardComponent,
  ],
})
export class LocationMapComponent implements OnInit {
  @ViewChild('mapContainer', { static: true }) mapContainerEl: ElementRef;

  @ViewChild('hereMap') public hereMapComponent: HereMapComponent;

  @Input() activities?: IActivityLocation[];
  @Input() boondockPoint?: IBoondockPoint;
  @Input() point?: IListingPoint;

  hideMap: boolean = true;

  get coordinates(): ILatLon {
    if (this.point?.coordinates) {
      return this.point.coordinates;
    }

    if (this.activities && this.activities.length > 0 && this.activities[0].coordinates) {
      return this.activities[0].coordinates;
    }

    return HelperFunctions.getDefaultLocation();
  }

  get points(): IListingPoint[] {
    if (this.point) {
      return [this.point];
    }
    return [];
  }

  get boondockPoints(): IBoondockPoint[] {
    if (this.boondockPoint) {
      return [this.boondockPoint];
    }
    return [];
  }

  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      this.hideMap = true;
    } else {
      this.hideMap = false;
      setTimeout(() => {
        this.hereMapComponent.buildMap();
      }, 250);
    }
  }
}
